import * as tslib_1 from "tslib";
import axios from 'axios';
var VideoMetadataApi = /** @class */ (function () {
    function VideoMetadataApi(token, baseURL) {
        this.token = token;
        this.axios = axios.create({
            baseURL: baseURL,
            headers: {
                Authorization: token,
            },
        });
    }
    VideoMetadataApi.prototype.getVideoMetadata = function (videoUrl) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.axios.get('/oembed', {
                        params: {
                            url: videoUrl,
                        },
                    })];
            });
        });
    };
    return VideoMetadataApi;
}());
export { VideoMetadataApi };
//# sourceMappingURL=VideoMetadataApi.js.map